import { GameOverLayer } from './../layers/GameOverLayer';
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { BoardContainer } from "../BoardContainer";
import { BoardScene } from "../BoardScene";
import { ColyseusManager } from "../../../ColyseusManager";
import { GameManager } from "../../../GameManager";
import * as Carrom from "carrom-king-engine";

export class BoardManager {

    protected ready: boolean;
    protected t: number;
    protected timeStep: number;
    protected timerEvent: Phaser.Time.TimerEvent;

    private timeEmojiSelected: number;

    constructor() {

        GameVars.tutorialMode = false;
        GameVars.turnCompleted = true;
        GameVars.waintingTurn = false;
        GameVars.winningPlayerId = null;
        GameVars.paused = false;
        GameVars.gameOver = false;
        GameVars.stake = 400;
        GameVars.time = 0;
        GameVars.connection = true;
        GameVars.needSendTurnData = false;

        GameVars.queenNeedsToBeCovered = false;

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
            GameVars.playerColor = GameVars.reversedBoard ? Carrom.Color.WHITE : Carrom.Color.BLACK;
            GameVars.adversaryColor = GameVars.reversedBoard ? Carrom.Color.BLACK : Carrom.Color.WHITE;
        } else {
            GameVars.playerColor = null;
            GameVars.adversaryColor = null;
        }

        GameVars.playerData.score = 0;
        GameVars.playerData.pocketedPucks = 0;

        GameVars.adversaryData.score = 0;
        GameVars.adversaryData.pocketedPucks = 0;
    
        this.ready = false;
        this.t = 0;
        this.timeStep = 250; // in milliseconds
        this.timeEmojiSelected = 0;

        GameVars.carromConfig = new Carrom.Config();
        GameVars.carromConfig.friction = GameVars.friction
        console.log(GameVars.carromConfig)

        GameVars.carromEngine = new Carrom.Engine(GameVars.carromConfig);

        GameVars.pucks = this.getPucksStartConfiguration();

        GameVars.carromEngine.addEventListener(Carrom.Event.TURN_COMPLETED, this.onTurnCompleted, this);
        GameVars.carromEngine.addEventListener(Carrom.Event.DISK_POCKETED, this.onDiskPocketed, this);
        GameVars.carromEngine.addEventListener(Carrom.Event.CONTACT_DISK_DISK, this.onContactDiskDisk, this);
        GameVars.carromEngine.addEventListener(Carrom.Event.CONTACT_DISK_BORDER, this.onContactDiskBorder, this);
    }

    public update(): void {

        if (!this.ready) {
            this.ready = true;
            console.log("PLAYING AGAINT BOT? ", GameVars.playingAgainstBot)
            ColyseusManager.sendMessage("PLAYER READY", {pucks: GameVars.pucks, playingAgainstBot: GameVars.playingAgainstBot});
        }

        if (!GameVars.turnCompleted) {

            if (GameConstants.SLOW_MOTION) {

                const t = Date.now();

                if (t - this.t < this.timeStep) {
                    return;
                }
    
                this.t = t;
            } 

            GameVars.carromEngine.update();
        }   
    }

    public onBothPlayersReady(startingPlayerId: string): void {

        console.log("clear show opponent left message ");

        GameVars.currentTurnPlayerId = startingPlayerId;

        BoardScene.currentInstance.onNewTurn(true);
    }

    public shoot(strikerPosition: Carrom.Vector2D, strikerVelocity: Carrom.Vector2D): void {

        GameVars.turnCompleted = false;
        GameVars.waintingTurn = false;
        GameVars.time = 0;

        GameVars.prevPucks = GameVars.pucks.slice(0);

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
           
            let color: string;

            if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                color = GameVars.playerColor;
            } else {
                color = GameVars.adversaryColor;
            }
           
            GameVars.carromEngine.shoot(
                strikerPosition, 
                GameVars.pucks, 
                strikerVelocity, 
                GameVars.gameMode, 
                color, 
                GameVars.queenNeedsToBeCovered
            );

            ColyseusManager.sendMessage("SHOT", { 
                "strikerPosition": {x: strikerPosition.x, y: strikerPosition.y}, 
                "pucks": GameVars.pucks,
                "strikerVelocity": {x: strikerVelocity.x, y: strikerVelocity.y},
                "gameMode": GameVars.gameMode,
                "color": color,
                "queenNeedsToBeCovered": GameVars.queenNeedsToBeCovered,
                "freestyleWinningScore": null,
                "playerScore": null
            });
        
        } else {

            let playerScore: number;

            if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                playerScore = GameVars.playerData.score;
            } else {
                playerScore = GameVars.adversaryData.score;
            }

            GameVars.carromEngine.shoot(
                strikerPosition, 
                GameVars.pucks, 
                strikerVelocity, 
                GameVars.gameMode, 
                null, 
                GameVars.queenNeedsToBeCovered,
                GameConstants.FREESTYLE_WINNING_SCORE,
                playerScore
            );

            ColyseusManager.sendMessage("SHOT", { 
                "strikerPosition": {x: strikerPosition.x, y: strikerPosition.y}, 
                "pucks": GameVars.pucks,
                "strikerVelocity": {x: strikerVelocity.x, y: strikerVelocity.y},
                "gameMode": GameVars.gameMode,
                "color": null,
                "queenNeedsToBeCovered": GameVars.queenNeedsToBeCovered,
                "freestyleWinningScore": GameConstants.FREESTYLE_WINNING_SCORE,
                "playerScore": playerScore
            });
        }

        GameVars.queenNeedsToBeCovered = false;

        BoardScene.currentInstance.onShot();
    }

    public replicateShot(strikerPosition: {x: number, y: number}, strikerVelocity: {x: number, y: number}, ): void {

        BoardContainer.currentInstance.strikerPosition = strikerPosition;

        GameVars.turnCompleted = false;
        GameVars.waintingTurn = false;

        GameVars.prevPucks = GameVars.pucks.slice(0);

        GameVars.carromEngine.shoot(
            new Carrom.Vector2D(strikerPosition.x, strikerPosition.y), 
            GameVars.pucks, 
            new Carrom.Vector2D(strikerVelocity.x, strikerVelocity.y), 
            GameVars.gameMode, 
            GameVars.adversaryColor, 
            GameVars.queenNeedsToBeCovered,
            GameConstants.FREESTYLE_WINNING_SCORE,
            GameVars.adversaryData.score
        );

        GameVars.queenNeedsToBeCovered = false;

        BoardScene.currentInstance.onShot();
    }

    public showMenu(): void {

        GameVars.paused = true;

        BoardScene.currentInstance.showMenu();
    }

    public hideMenu(): void {

        GameVars.paused = false;

        BoardScene.currentInstance.hideMenu();
    }

    public showEmojisMenu(): void {

        BoardScene.currentInstance.showEmojisMenu();
    }

    public hideEmojisMenu(): void {
        
        BoardScene.currentInstance.hideEmojisMenu();
    }

    public onEmojiSelected(i: number): void {

        const now = new Date().getTime();

        if (now - this.timeEmojiSelected < 2000) {
            return;
        }

        this.timeEmojiSelected = now;

        ColyseusManager.sendMessage("EMOJI SELECTED", i);

        BoardScene.currentInstance.showEmoji(i, true);
    }

    public onGameOver(winningPlayerId: string, timeout?: boolean): void {
        if (GameVars.gameOver) {
            return;
        }

        GameVars.winningPlayerId = winningPlayerId;
    
        GameVars.paused = true;
        GameVars.gameOver = true;

        GameManager.onGameOver();
        
        BoardScene.currentInstance.onGameOver(timeout);
    }

    public onSecondPassed(time?: number): void {

        GameVars.time = time || GameVars.time + 1;

        BoardScene.currentInstance.updateTimer();
    }

    public onTimeOver(currentTurnPlayerId: string, turnsToForceGameOver: number): void {

        if (GameVars.turnData && GameVars.turnData.hasQueenBeenPocketed && !GameVars.turnData.skipQueenCovering && !this.diskIsAlreadyOnBoard(0)) {
            this.restituteQueen();
        }

        GameVars.currentTurnPlayerId = currentTurnPlayerId;
        GameVars.turnsToForceGameOver = turnsToForceGameOver;

        GameVars.time = 0;

        GameVars.turnData = null;

        BoardScene.currentInstance.onNewTurn();
    }

    protected onTurnCompleted(
        strikerPosition: Carrom.Vector2D, 
        pucks: Carrom.Puck [], 
        pocketedPucks: Carrom.Puck [], 
        alternatePlayer: boolean, 
        hasQueenBeenPocketed: boolean, 
        restituteQueen: boolean, 
        skipQueenCovering: boolean,
        score: number,
        hasPlayerWon: boolean,
        hasAdversaryWon: boolean,
        faults: string []
        ): void {

        GameVars.turnCompleted = true;
        GameVars.waintingTurn = true;

        GameVars.turnData = {
            strikerPosition: strikerPosition,
            pucks: pucks,
            pocketedPucks: pocketedPucks,
            alternatePlayer: alternatePlayer, 
            hasQueenBeenPocketed: hasQueenBeenPocketed, 
            restituteQueen: restituteQueen, 
            skipQueenCovering: skipQueenCovering,
            score: score,
            hasPlayerWon: hasPlayerWon,
            hasAdversaryWon: hasAdversaryWon,
            faults: faults
        };
    }

    public onValidTurn(): void {

        GameVars.waintingTurn = false;

        GameVars.pucks = GameVars.turnData.pucks.slice(0);

        BoardScene.currentInstance.setPucksPositions();

        if (GameVars.gameMode === Carrom.GameMode.FREESTYLE) {

            if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                GameVars.playerData.score = GameVars.turnData.score;
            } else {
                GameVars.adversaryData.score = GameVars.turnData.score;
            }
        }

        if (GameVars.turnData.hasPlayerWon || GameVars.turnData.hasAdversaryWon) {

            if (GameVars.gameOver) {
                return;
            }

            GameVars.gameOver = true;

            if (GameVars.turnData.hasAdversaryWon) {

                if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                    GameVars.winningPlayerId = GameVars.adversaryData.id;
                } else {
                    GameVars.winningPlayerId = GameVars.playerData.id;
                }

            } else {
                
                GameVars.winningPlayerId = GameVars.currentTurnPlayerId;
            }

            GameManager.onGameOver();

            BoardScene.currentInstance.onGameOver(false);
            
        } else {

            let color;
            let lastTurn = GameVars.currentTurnPlayerId === GameVars.playerData.id ? GameVars.playerData.id : GameVars.adversaryData.id;

            if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                color = GameVars.playerColor;
            } else {
                color = GameVars.adversaryColor;
            }

            if (GameVars.turnData.alternatePlayer) {

                GameVars.currentTurnPlayerId = GameVars.currentTurnPlayerId === GameVars.playerData.id ? GameVars.adversaryData.id : GameVars.playerData.id;
                GameVars.queenNeedsToBeCovered = false;

            } else if (GameVars.turnData.hasQueenBeenPocketed && !GameVars.turnData.skipQueenCovering) {
                
                GameVars.queenNeedsToBeCovered = true;
            }

            if (GameVars.turnData.restituteQueen) {

                this.restituteQueen();
            }

            if (GameVars.turnData.faults.length) {
                for (let i = 0; i < GameVars.turnData.pocketedPucks.length; i++) {

                    let lastPuckFault = false;

                    for (let k = 0; k < GameVars.turnData.faults.length; k++) {
                        if (GameVars.turnData.faults[k] === Carrom.Fault.LAST_PUCK_POCKETED || GameVars.turnData.faults[k] === Carrom.Fault.LAST_ADVERSARY_PUCK_POCKETED) {
                            lastPuckFault = true;
                        }
                    }

                    if (GameVars.gameMode === Carrom.GameMode.FREESTYLE || GameVars.turnData.pocketedPucks[i].color === color || lastPuckFault) {

                        if (GameVars.turnData.pocketedPucks[i].color !== Carrom.Color.RED) {

                            if (GameVars.playingAgainstBot) {
                                if (!this.diskIsAlreadyOnBoard(GameVars.turnData.pocketedPucks[i].id)) {

                                    if (GameVars.gameMode === Carrom.GameMode.FREESTYLE) {
    
                                        let score = 0;
                                        
                                        if (!lastPuckFault) {
                                            if (GameVars.turnData.pocketedPucks[i].color === Carrom.Color.BLACK) {
                                                score -= 10;
                                            } else if (GameVars.turnData.pocketedPucks[i].color === Carrom.Color.WHITE) {
                                                score -= 20;
                                            }
                                        }
    
                                        if (lastTurn === GameVars.playerData.id) {
                                            GameVars.playerData.score += score;
                                        } else {
                                            GameVars.adversaryData.score += score;
                                        }
                                    }
    
                                    const disk = {
                                        id: GameVars.turnData.pocketedPucks[i].id, 
                                        color: GameVars.turnData.pocketedPucks[i].color, 
                                        position: Carrom.Maths.getValidDiskPosition({x: 0, y: 0}, GameVars.pucks, GameVars.carromEngine.puckRadius), 
                                        value: GameVars.turnData.pocketedPucks[i].value
                                    };
                        
                                    GameVars.pucks.push(disk);
                                    BoardScene.currentInstance.onDiskRestituted(disk, true);
                                    
                                }
                            } else {
                                
                                const disk = {
                                    id: GameVars.turnData.pocketedPucks[i].id, 
                                    color: GameVars.turnData.pocketedPucks[i].color, 
                                    position: Carrom.Maths.getValidDiskPosition({x: 0, y: 0}, GameVars.pucks, GameVars.carromEngine.puckRadius), 
                                    value: GameVars.turnData.pocketedPucks[i].value
                                };

                                BoardScene.currentInstance.onDiskRestituted(disk, false);
                            }

                            
                        }   
                    }
                }
            }

            BoardScene.currentInstance.onNewTurn();
        }
    }

    private restituteQueen(): void {

        const queen = {
            id: 0, 
            color: Carrom.Color.RED, 
            position: Carrom.Maths.getValidQueenPosition(GameVars.pucks, GameVars.carromEngine.puckRadius), 
            value: GameVars.carromEngine.pucksValues.red
        };

        GameVars.pucks.push(queen);

        GameVars.queenNeedsToBeCovered = false;

        BoardScene.currentInstance.onQueenRestituted(queen.position);
    }

    private diskIsAlreadyOnBoard(id: number): boolean {

        for (let i = 0; i < GameVars.pucks.length; i++) {
            if (id === GameVars.pucks[i].id) {
                return true;
            }
        }

        return false;
    }

    private onDiskPocketed(disk: Carrom.Disk): void {

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            if (GameVars.reversedBoard) {

                if (disk.color === Carrom.Color.BLACK) {
                    GameVars.adversaryData.pocketedPucks ++;
                } else if (disk.color === Carrom.Color.WHITE) {
                    GameVars.playerData.pocketedPucks ++;
                }

            } else {
                if (disk.color === Carrom.Color.BLACK) {
                    GameVars.playerData.pocketedPucks ++;
                } else if (disk.color === Carrom.Color.WHITE) {
                    GameVars.adversaryData.pocketedPucks ++;
                }
            } 
        } 
        
        BoardScene.currentInstance.onDiskPocketed(disk);
    }

    private getPucksStartConfiguration(): Carrom.Puck [] {
        
        let pucks: Carrom.Puck [] = [];
        let id = 0;

        pucks.push({id: id++, color: Carrom.Color.RED, position: new Carrom.Vector2D(0, 0), value: GameVars.carromEngine.pucksValues.red});

        let angle = 30;
        const puckRadius = GameVars.carromEngine.puckRadius;

        for (let i = 0; i < 6; i++) {

            let x = 1.01 * puckRadius * 2 * Math.cos(angle * Math.PI / 180);
            let y = 1.01 * puckRadius * 2 * Math.sin(angle * Math.PI / 180);

            pucks.push({
                id: id ++,
                color: i %  2 === 0 ? Carrom.Color.BLACK : Carrom.Color.WHITE,
                position: new Carrom.Vector2D(x, y), 
                value: i %  2 === 0 ? GameVars.carromEngine.pucksValues.black : GameVars.carromEngine.pucksValues.white
            });

            x = 1.01 * puckRadius * 2 * Math.sqrt(3) * Math.cos((angle + 30 ) * Math.PI / 180);
            y = 1.01 * puckRadius * 2 * Math.sqrt(3) * Math.sin((angle + 30 ) * Math.PI / 180);

            pucks.push({
                id: id ++,
                color: Carrom.Color.BLACK,
                position: new Carrom.Vector2D(x, y),
                value: GameVars.carromEngine.pucksValues.black 
            });

            x = 1.01 * puckRadius * 4 * Math.cos(angle * Math.PI / 180);
            y = 1.01 * puckRadius * 4 * Math.sin(angle * Math.PI / 180);

            pucks.push({
                id: id ++,
                color: Carrom.Color.WHITE,
                position: new Carrom.Vector2D(x, y),
                value: GameVars.carromEngine.pucksValues.white
            });

            angle += 60;
        }

        // TODO: BORRAR ESTO
        // PARA FORZAR UNAS POSICIONES DETERMINADAS

        // let pucksData = [
        //     {"id": 0, "color": "red", "position": {"xValue": 29000, "yValue": 31000}}, 
        //     {"id": 1, "color": "black", "position": {"xValue": 25000, "yValue": 28000}}, 
        //     {"id": 2, "color": "white", "position": {"xValue": -27907.457700000003, "yValue": -20497.619690000003}}];
        // let pucksData = [{"id": 0, "color": "red", "position": {"xValue": -22343.49349, "yValue": 25687.475960000003}}, {"id": 2, "color": "black", "position": {"xValue": -27907.457700000003, "yValue": -20497.619690000003}}, {"id": 4, "color": "black", "position": {"xValue": -20381.36615, "yValue": -10059.13292}}, {"id": 6, "color": "black", "position": {"xValue": 5883.875040000001, "yValue": -8841.32091}}, {"id": 8, "color": "black", "position": {"xValue": 30000, "yValue": -30000}}, {"id": 5, "color": "white", "position": {"xValue": 30000, "yValue": 30000}}];
        // let pucksData = [{"id": 0, "color": "red", "position": {"xValue": -29500, "yValue": 31000}}, {"id": 1, "color": "white", "position": {"xValue": -26000, "yValue": 29000}}, {"id": 3, "color": "black", "position": {"xValue": 5695.822370000001}}, {"id": 4, "color": "black", "position": {"xValue": -5695.822370000001}}];
        // pucks = [];
        

        // for (let i = 0; i < pucksData.length; i ++) {
            
        //     const id = pucksData[i].id;
        //     const color = pucksData[i].color;
        //     const x = pucksData[i].position.xValue;
        //     const y = pucksData[i].position.yValue;

        //     let value: number;

        //     if (color === Carrom.Color.RED) {
        //         value = GameVars.carromEngine.pucksValues.red;
        //     } else if (color === Carrom.Color.WHITE) {
        //         value = GameVars.carromEngine.pucksValues.white;
        //     } else {
        //         value = GameVars.carromEngine.pucksValues.black;
        //     }

        //     pucks.push({id: id, color: color, position: new Carrom.Vector2D(x, y), value: value});
        // }

        return pucks;
    }

    private onContactDiskDisk(disk1Velocity: Carrom.Vector2D, disk2Velocity: Carrom.Vector2D): void {

        BoardContainer.currentInstance.onContactDiskDisk(disk1Velocity, disk2Velocity);
    }

    private onContactDiskBorder(diskNormalVelocity: Carrom.Vector2D): void {
        
        BoardContainer.currentInstance.onContactDiskBorder(diskNormalVelocity);
    }

}
